import React from "react";
import "url-polyfill"; /* https://www.npmjs.com/package/url-polyfill */
import { Helmet } from "react-helmet"; /* https://github.com/nfl/react-helmet"; */
import i18n from "../../i18next";
import { Container, Row } from "reactstrap";
import heroImageUrl from "../../images/portfolioiRetailAR/iRetailARHero.jpg";
import HeroContainer from "./commons/HeroContainer";
import IntroductionSection from "./commons/IntroductionSection";
import iRetailARLogo from "../../images/portfolioiRetailAR/logo.png";
import { DesktopView, MobileiXBlackView } from "./commons/WorkGallery";
import { ConceptKeyPointsListSection } from "./commons/ConceptSection";
import NextIndicatorSection from "./commons/NextIndicatorSection";

/* screenshots */
import desktopScreenshotURL01 from "../../images/portfolioiRetailAR/desktopScreenshot01.jpg";
// import desktopScreenshotURL02 from "../../images/portfolioiRetailAR/desktopScreenshot02.jpg";
// import desktopScreenshotURL03 from "../../images/portfolioiRetailAR/desktopScreenshot03.jpg";
import mobileScreenshotURL01 from "../../images/portfolioiRetailAR/mobileScreenshot01.jpg";
import mobileScreenshotURL02 from "../../images/portfolioiRetailAR/mobileScreenshot02.jpg";
import mobileScreenshotURL03 from "../../images/portfolioiRetailAR/mobileScreenshot03.jpg";
import mobileScreenshotURL04 from "../../images/portfolioiRetailAR/mobileScreenshot04.jpg";
import mobileScreenshotURL05 from "../../images/portfolioiRetailAR/mobileScreenshot05.jpg";
import mobileScreenshotURL06 from "../../images/portfolioiRetailAR/mobileScreenshot06.jpg";
import mobileScreenshotURL07 from "../../images/portfolioiRetailAR/mobileScreenshot07.jpg";
import mobileScreenshotURL08 from "../../images/portfolioiRetailAR/mobileScreenshot08.jpg";
import mobileScreenshotURL09 from "../../images/portfolioiRetailAR/mobileScreenshot09.jpg";

export default class iRetailAR extends React.Component {
  constructor(props) {
    super(props);
    this.state = { windowScrollY: 0 };
  }

  componentDidMount() {
    /* inital scoll settting to be on the top */
    window.scrollTo(0, 0);

    window.onscroll = () => {
      /* need to set scroll in parent prevent glitch */
      this.setState({ windowScrollY: window.scrollY });
    }
  }

  render() {
    const url = new URL(window.location.href);
    const helmetContent = i18n.t("iRetailARPortfolio.introduction");
    const helmetTitle = `${i18n.t("iRetailARPortfolio.abbriTitle")} - ${i18n.t("jsonLdOrganization.shortCompName")}`;
    return (
      <div className="specificPortfolio">
        <Helmet>
          <title>{helmetTitle}</title>
          <meta name="description" content={helmetContent} />
          {/* Open Graph Protocal (Facebook), see: http://ogp.me/ */}
          <meta property="og:title" content={helmetTitle} />
          <meta property="og:url" content={`${url.href}`} />
          <meta property="og:image" content={desktopScreenshotURL01} />
          <meta property="og:description" content={helmetContent} />
          {/* canonical url, see: https://support.google.com/webmasters/answer/139066 */}
          <link rel="canonical" href={`${url.href}`} />
        </Helmet>
        <HeroContainer
          heroImageUrl={heroImageUrl}
          title="iRetail AR"
        />
        <Container fluid={true} className="mainSections">
          <div className="pt-2 pt-md-3 pt-lg-4">
            <IntroductionSection
              title={i18n.t("iRetailARPortfolio.title")}
              squareImgUrl={iRetailARLogo}
              description={i18n.t("iRetailARPortfolio.introduction")}
              yearMonthText="December 2017"
              windowScrollY={this.state.windowScrollY}
              externalLinkURL={"https://itunes.apple.com/us/app/retail-connect/id1326705474?ls=1&mt=8"}
            />
            <Container>
              <Row className="showCaseSection p-1 p-sm-2 px-lg-4 py-md-3">
                <DesktopView
                  screenshotUrls={[desktopScreenshotURL01]}
                />
                <MobileiXBlackView
                  screenshotUrls={[mobileScreenshotURL01, mobileScreenshotURL02, mobileScreenshotURL03, mobileScreenshotURL04, mobileScreenshotURL05, mobileScreenshotURL06, mobileScreenshotURL07, mobileScreenshotURL08, mobileScreenshotURL09]}
                />
                <ConceptKeyPointsListSection
                  keyPoints={i18n.t("iRetailARPortfolio.keypoints", {returnObjects: true})}
                />
              </Row>
            </Container>
            <NextIndicatorSection
              linkTo={"/portfolio/mammography"}
              linkText={i18n.t("mammographyPortfolio.title")}
              windowScrollY={this.state.windowScrollY}
            />
          </div>
        </Container>
      </div>
    )
  }
}